import { AppDispatch } from '../../../index';
import { setContractor, clearContractor, setContractorError, setContractorLoading } from './reducer';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

// Simple cache implementation
const cache = new Map<string, { data: any; timestamp: number }>();
const CACHE_DURATION = 30000; // 30 seconds

const getCachedData = (key: string) => {
  const cached = cache.get(key);
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }
  return null;
};

const setCachedData = (key: string, data: any) => {
  cache.set(key, { data, timestamp: Date.now() });
};

export const fetchContractorByIdThunk = (contractorId: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setContractorLoading(true));

    // Check cache first
    const cacheKey = `contractor-${contractorId}`;
    const cachedData = getCachedData(cacheKey);
    if (cachedData) {
      dispatch(setContractor(cachedData));
      return;
    }

    const firestore = firebase.firestore();
    const contractorsRef = firestore.collection('contractors');
    
    const querySnapshot = await contractorsRef
      .where('contractorId', '==', contractorId)
      .limit(1)
      .get();

    if (querySnapshot.empty) {
      throw new Error('Contractor not found');
    }

    const contractorDoc = querySnapshot.docs[0];
    const contractorData = contractorDoc.data();

    const contractor = {
      ...contractorData,
      id: contractorDoc.id,
      businessName: contractorData.businessName || '',
      contractorId: contractorData.contractorId || '',
      searches: contractorData.searches || []
    };

    // Cache the data
    setCachedData(cacheKey, contractor);

    dispatch(setContractor(contractor));
    
    // Store contractor data and set isContractor flag
    sessionStorage.setItem('currentContractor', JSON.stringify(contractor));
    sessionStorage.setItem('isContractor', 'true');

    // Trigger storage event to update UserContext
    window.dispatchEvent(new Event('storage'));

    console.log("fetchContractorByIdThunk Contractor: ", contractor);
  } catch (error: any) {
    console.error('Error fetching contractor:', error);
    dispatch(setContractorError(error.message));
  }
};

export const clearContractorThunk = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(clearContractor());
    sessionStorage.removeItem('currentContractor');
    sessionStorage.removeItem('isContractor');
    
    // Trigger storage event to update UserContext
    window.dispatchEvent(new Event('storage'));
  } catch (error: any) {
    console.error('Error clearing contractor:', error);
    dispatch(setContractorError(error.message));
  }
};

export const handleContractorAuth = (contractorId: string | null) => async (dispatch: AppDispatch) => {
  if (!contractorId) {
    dispatch(clearContractorThunk());
    return;
  }

  try {
    await dispatch(clearContractorThunk());
    await dispatch(fetchContractorByIdThunk(contractorId));
  } catch (error: any) {
    console.error('Error handling contractor auth:', error);
    dispatch(setContractorError(error.message));
  }
};